export default __webpack_public_path__ + "static/media/2488.819578d3.png";